module.exports = __webpack_public_path__ + "static/media/snapchat.08ca7afb.png";